import * as React from 'react'
import ReactSVG from 'react-svg'

import AdvantageTestingIcon from 'assets/img/social-proof/adv-test.svg'
import CareComIcon from 'assets/img/social-proof/care-com.svg'
import DailyMailIcon from 'assets/img/social-proof/daily-mail.svg'
import ForbesIcon from 'assets/img/social-proof/forbes.svg'
import HebrewUniversityIcon from 'assets/img/social-proof/hebrew-u.svg'
import TexasMedicalCenterIcon from 'assets/img/social-proof/tmc.svg'
import classnames from 'classnames'
import styles from './style.module.scss'

interface IReduxStateProps {}
interface IReduxDispatchProps {}
interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}
interface IProps extends IReduxProps {}

export const SocialProof: React.FC<IProps> = () => {
  return (
    <div className={styles.wrap}>
      <div className={styles.wrap__container}>
        <div className={styles.container}>
          <div className={styles.container__section}>
            <div className={styles.socials}>
              <div
                className={classnames(
                  styles.socials__item,
                  styles.socials__item_tmc
                )}
              >
                <ReactSVG
                  className={styles.icon}
                  src={TexasMedicalCenterIcon}
                />
              </div>
              <div
                className={classnames(
                  styles.socials__item,
                  styles['socials__item_hebrew-u']
                )}
              >
                <ReactSVG className={styles.icon} src={HebrewUniversityIcon} />
              </div>
              <div
                className={classnames(
                  styles.socials__item,
                  styles['socials__item_adv-test']
                )}
              >
                <ReactSVG className={styles.icon} src={AdvantageTestingIcon} />
              </div>
            </div>
          </div>
          <div
            className={classnames(
              styles.container__section,
              styles.container__section_seen
            )}
          >
            <div className={classnames(styles.socials, styles.socials_seen)}>
              <div className={styles.socials__item}>
                <ReactSVG className={styles.icon} src={CareComIcon} />
              </div>
              <div className={styles.socials__item}>
                <ReactSVG className={styles.icon} src={ForbesIcon} />
              </div>
              <div className={styles.socials__item}>
                <ReactSVG className={styles.icon} src={DailyMailIcon} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Payment/SocialProof/index.tsx